import screenSize from './screenSize';

export default [screenSize];
